module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/desktop@2x_436b15.jpg";